import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {YoutubeLikeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/like';
import {useTranslation} from 'react-i18next';

const YoutubeLikeTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<YoutubeLikeTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'triggerIntegrations.like',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} withRefresh />;
};

export default YoutubeLikeTriggerActionCtaComponentPreview;
